export default __webpack_public_path__ + "alberta-productlist.146ed62eafd72859ab41.svg";